<terra-dialog-header>
  <h1>{{data.title}}</h1>
</terra-dialog-header>

<mat-dialog-content>
  <div class="share-approve">
    <div class="job-ad">
      <mat-checkbox color="primary" [checked]="agreed" [disabled]="data.checkboxDisabled">
        {{data.checkboxLabel}}
      </mat-checkbox>
    </div>
    <div class="investmentEntityDropDown">
      <mat-form-field appearance="outline" class="w-full">
        <mat-select [placeholder]="data?.dropdownPlaceholder" [formControl]="selectedItem" panelClass="investmentEntityDropDown">
          <mat-select-trigger>
            @if (selectedItem?.value) {
              <ng-container *ngTemplateOutlet="selectTemplate; context: { $implicit: selectedItem.value }" />
            }
        </mat-select-trigger>
          @for (item of data?.options; track item) {
            <mat-option [value]="item">
              <terra-investor [investor]="item" />
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button type="submit" mat-flat-button class="save-button" [mat-dialog-close]="selectedItem">
    {{data.confirmButton || 'Confirm'}}
  </button>
</mat-dialog-actions>

<ng-template #selectTemplate let-selected>
  <terra-investor [investor]="selected" />
</ng-template>
